import { render, staticRenderFns } from "./fieldFilesUploader.vue?vue&type=template&id=442dc0bc&lang=pug&"
import script from "./fieldFilesUploader.vue?vue&type=script&lang=js&"
export * from "./fieldFilesUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports